const initialState = {
  step: 2,
  user: {
    no: "",
    nm: "",
    birth: "",
    gender: "",
    cph: "",
    di: "",
    ci: "",
    isOrgUser: "",
    isUser: "",
    pwd: "",
    pwdChk: "",
    email: "",
    zip: "",
    addr: "",
    addrDtl: "",
    allYn: "N",
    tncYn: "N",
    plcyYn: "N",
    pushYn: "N",
    mktYn: "N",
    mktPushYn: "N",
    mktSmsYn: "N",
    mktEmailYn: "N",
    gnrPushYn: "Y",
    favMt: "",
    mblRctYn: "N",
    mainTp: "1",
  },
};

export const INIT = "INIT";
export const init = () => ({
  type: INIT,
});

export const SET_STEP = "SET_STEP";
export const stepAction = (data) => ({
  type: SET_STEP,
  payload: data,
});

export const SET_USER = "SET_USER";
export const setUserAction = (data) => ({
  type: SET_USER,
  payload: data,
});

export default function joinReducer(state = initialState, action) {
  const { type, payload, error } = action;
  console.log("payload", payload);
  switch (type) {
    case INIT:
      return {
        ...initialState,
      };
    case SET_STEP:
      return {
        ...state,
        step: payload,
      };
    case SET_USER:
      return {
        ...state,
        user: payload,
      };
    default:
      return state;
  }
}
